import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/dashboard")({
  component: lazyImportRouteComponent(
    () => import("./-components/DashboardPage"),
    "DashboardPage"
  ),
  beforeLoad: (context) => {
    return {
      getTitle: () => context.context.t && context.context.t("Dashboard"),
    }
  },
})
